import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
export default function Navbar(props) {
  return (

  <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
        <a className="navbar-brand" href="/" >{props.title}</a>
         <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
          </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          <li className="nav-item">
            <Link className="nav-link active" aria-current="page" to="/">Home</Link>
            {/* <a className="nav-link active" aria-current="page" href="#">Home</a> */}
          </li>
          <li className="nav-item">
          <Link className="nav-link" to="/about">About</Link>
          {/* <a className="nav-link" href="/about">About</a> */}
          </li>
        </ul>
      <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`}>
          <input className="form-check-input mx-1" onClick={props.toggleMode} type="checkbox" id="flexSwitchCheckDefault"/>
            <label className="form-check-label" style={{color:"black"}} htmlFor="flexSwitchCheckDefault"><strong>Dark</strong></label>
      </div>
      <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`}>
          <input className="form-check-input mx-1"onClick={()=>{props.toggleNewMode('primary')}} type="checkbox" id="flexSwitchCheckDefault"/>
            <label className="form-check-label" style={{color:"blue"}} htmlFor="flexSwitchCheckDefault"><strong>Blue</strong></label>
      </div>
      <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`}>
        <input className="form-check-input mx-1"onClick={()=>{props.toggleNewMode('warning')}} type="checkbox" id="flexSwitchCheckDefault"/>
          <label className="form-check-label"style={{color:"yellow"}} htmlFor="flexSwitchCheckDefault"><strong>Yellow</strong></label>
      </div>
      <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`}>
          <input className="form-check-input mx-1"onClick={()=>{props.toggleNewMode('success')}} type="checkbox" id="flexSwitchCheckDefault"/>
          <label className="form-check-label" style={{color:"green"}} htmlFor="flexSwitchCheckDefault"><strong>Green</strong></label>
       </div>
      </div>
      
  </nav>
        )
      }

Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    aboutText: PropTypes.string.isRequired
  }
Navbar.defaultProps = {
    title: 'Set title here',
    aboutText: 'About'
};          
